<template>
    <v-alert :color="color" text type="info" :id="id" :dismissible="dismissible">
        {{ text }}
    </v-alert>
</template>
<script>
export default {
    name: 'info-alert',
    props: {
        text: String,
        id: String,
        color: String,
        dismissible: Boolean
    }
};
</script>